import { isSupportedDataType, isValidCurrency, isValidExchangeTickerSymbol } from '../helpers/args-validators';
import { FunctionCallCache } from '../helpers/functionCallCache';
import { FunctionLocationTracker } from '../helpers/functionLocationTracker';
import { KeyBuilder } from '../helpers/keyBuilder';
const SUPPORTED_DATETYPES = ['Legal_Name', 'Display_Name', 'IPO_Offering_Price', 'Date_First_Trading'];
function validateArgs(symbol, dataType, currency) {
    if (!isValidExchangeTickerSymbol(symbol)) {
        throw new CustomFunctions.Error(CustomFunctions.ErrorCode.invalidValue, 'Invalid symbol (expected format: EXCHANGE:TICKER)');
    }
    if (!isSupportedDataType(SUPPORTED_DATETYPES, dataType)) {
        throw new CustomFunctions.Error(CustomFunctions.ErrorCode.invalidValue, 'Invalid data type');
    }
    if (dataType.toLocaleLowerCase() === 'ipo_offering_price') {
        if (currency == null) {
            throw new CustomFunctions.Error(CustomFunctions.ErrorCode.invalidValue, "Currency is required for IPO offering price");
        }
        if (currency != null && !isValidCurrency(currency)) {
            throw new CustomFunctions.Error(CustomFunctions.ErrorCode.invalidValue, "Invalid currency (expected format: e.g., 'USD')");
        }
    }
    return true;
}
let delegate = () => {
    throw new CustomFunctions.Error(CustomFunctions.ErrorCode.notAvailable, 'Initializing… press F9 to recalc.');
};
export function setCompanyDataDelegate(fn) {
    delegate = fn;
}
export function companyDataWrapper(symbol, dataType, currency, invocation) {
    return delegate(symbol, dataType, currency, invocation);
}
export function companyDataImpl(symbol, dataType, currency, invocation) {
    if (currency != null) {
        validateArgs(symbol, dataType, currency);
    }
    else {
        validateArgs(symbol, dataType);
    }
    const cache = FunctionCallCache.getInstance();
    const tracker = FunctionLocationTracker.getInstance();
    const args = { symbol, dataType, currency };
    const key = KeyBuilder.build('company_data', args);
    cache.registerByKey(key, { functionName: 'company_data', params: args });
    if (invocation?.address) {
        // the key contains the function name and args
        tracker.registerCell(key, invocation.address, `=ALPHA.COMPANY_DATA("${symbol}", "${dataType}")`);
        cache.setAutoRefresh(key);
    }
    return cache.getValueForExcelByKey(key);
}
//# sourceMappingURL=companyData.js.map